export default [
  {
    key: 'tilbud',
    position: 'top',
    attribute: 'taxonomies.Tilbud',
    copyKey: 'offer',
    copySelect: 'select_offer',
  },
  {
    key: 'aldersgruppe',
    position: 'top',
    attribute: 'taxonomies.Aldersgruppe',
    copyKey: 'aldersgruppe',
    copySelect: 'select_aldersgruppe',
  },
  {
    key: 'kommune',
    position: 'top',
    attribute: 'taxonomies.Kommune',
    copyKey: 'Kommune',
    copySelect: 'selectKommune',
  },
  {
    key: 'search',
    position: 'top',
    copyKey: 'searchTitle',
    copyPlaceholder: 'searchTitle',
  },

  {
    key: 'segment',
    position: 'panel',
    attribute: 'taxonomies.Segment',
    copyKey: 'segmentTitle',
  },
  {
    key: 'driftsform',
    position: 'panel',
    attribute: 'metadata.ssws_driftsform',
    copyKey: 'operatingMode',
  },
  {
    key: 'malgruppe',
    position: 'panel',
    attribute: 'taxonomies.Målgruppe',
    copyKey: 'targetGroup',
  },
  {
    key: 'Godkendelsesparagraf',
    position: 'panel',
    attribute: 'taxonomies.Godkendelsesparagraf',
    copyKey: 'Paragraffer',
  },
  {
    key: 'Ledigplads',
    position: 'panel',
    attribute: 'metadata.ssws_ledig-plats',
    copyKey: 'Ledigplads',
  },
];
